import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="border_subtitle">Behaviour</div>
                                            <p>Be aware of and receptive to the participant‘s behaviour,
                                                reactions and body language.</p>
                                            <p><span className="subtiltereg">Example Actions:</span> Observe and
                                                be open about the person‘s reactions, e.g. ‘you seem disgruntled
                                                about what I‘ve told you?‘ </p>
                                            <p>Don‘t make assumptions about how a participant will react, and
                                                don‘t make assumptions about why they react the way they do.</p>

                                            <div className="border_subtitle">Impact</div>
                                            <p>Impress upon the participant the effect that their current
                                                behaviour is having, and the impact change could bring.</p>
                                            <p><span className="subtiltereg">Example Actions:</span> Inform the
                                                participant of comments that have been made by other
                                                stakeholders: ‘the client said you were late delivering‘.</p>
                                            <p>Ask the participant to think from others‘ perspective about their
                                                behaviour: ‘do you think that Accounts would believe that you
                                                have been fully cooperative with them?‘</p>


                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span
                                                    className="heading">GIVING FEEDBACK TO DIFFERENT KINDS OF PEOPLE</span>
                                            </div>

                                            <p>We all react differently to feedback. If you don‘t consider the
                                                reaction you are likely to get from someone when you give them
                                                feedback there is a chance that your message will not be
                                                heard.</p>
                                            <p>Almost certainly, the following feedback personalities are
                                                working in your organisation. Before tackling a difficult issue
                                                with someone, think about which description fits them the best
                                                and let it guide your approach. Be aware though that these are
                                                just helpful metaphors; people will not fit perfectly into one
                                                category.</p>
                                            <div className="border_subtitle">The Sponge</div>
                                            <p>The Sponge is both open and receptive to feedback and will
                                                actively encourage others to critique their approach. They show
                                                a high desire for feedback on their performance.</p>
                                            <p>You will need to make sure that a feedback session with this
                                                individual allows time for two-way dialogue, plenty of
                                                exploration and translating thoughts into action. To make sure
                                                that this individual‘s need for feedback is met, plan for
                                                sessions at regular intervals. Be aware that behind the ‘perfect
                                                learner‘ exterior, the Sponge may be seeking reassurance to
                                                boost an underlying lack of confidence.</p>
                                            <p><span className="subtiltereg">Risk –</span> a constant desire for
                                                feedback may devalue important messages.</p>

                                            <div className="border_subtitle">The Glass Half Empty</div>
                                            <p>The Glass Half Empty has a tendency to focus in on negative
                                                feedback, magnify it and overly worry that it may lead to
                                                disaster – they will see a small personal flaw as being ‘the end
                                                of the world‘.</p>
                                            <p>To get the best out of a discussion you will need to help this
                                                individual put the feedback into perspective and look for ways
                                                that they can build on their strengths to overcome their
                                                weaknesses. You could help them check their perspective by
                                                asking questions like ‘what‘s the worst thing that could
                                                happen?‘ and ‘is this always the case or only in some
                                                situations?‘</p>
                                            <p><span className="subtiltereg">Risk –</span> the pessimist will
                                                only hear the bad, not the good, messages.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}